// extracted by mini-css-extract-plugin
module.exports = {"placement":"ProductPlacement_placement__vWS8-","diagrams":"ProductPlacement_diagrams__3hEDf"};